module.exports = __webpack_public_path__ + "static/media/hpprinter.c1669e5f.jpg";